<template>
  <div id="update">
    <div class="row">
      <div class="col-12">
        <h4 class="font-weight-bold">Actualización de registro - {{pqrId}}</h4>
      </div>
      <div class="col-12 mt-3">
        <form class="row" v-on:submit.prevent="updatePqr">
          
          <div class="col-12 col-md-6">
            <div class="card mb-3">
              <div class="card-header">
                <span class="font-weight-bold">Información del solicitante</span>
              </div>
              <div class="card-body">
                <h6 class="mb-3">
                  <span class="d-block font-weight-bold">Nombre completo:</span> {{pqr.user.name}}
                </h6>
                <h6 class="mb-3">
                  <span class="d-block font-weight-bold">Correo Electrónico:</span> {{pqr.user.email}}
                </h6>
                <h6 class="mb-3">
                  <span class="d-block font-weight-bold">Tipo de identificación:</span> {{pqr.user.documentType}}
                </h6>
                <h6 class="mb-3">
                  <span class="d-block font-weight-bold">Número de identificación:</span> {{pqr.user.documentNumber}}
                </h6>
                <h6 class="mb-3">
                  <span class="d-block font-weight-bold">Teléfono de Contacto:</span> {{pqr.user.phone}}
                </h6>
                <hr class="my-2">
                <h6 class="mb-3">
                  <span class="d-block font-weight-bold">Dirección:</span> {{pqr.user.address}}
                </h6>
                <h6 class="mb-3">
                  <span class="d-block font-weight-bold">Departamento:</span> {{pqr.user.state}}
                </h6>
                <h6 class="mb-3">
                  <span class="d-block font-weight-bold">Ciudad:</span> {{pqr.user.city}}
                </h6>
                <hr class="my-2">
                <h6 v-if="hasFile">
                  <span class="d-block font-weight-bold">Documento adjunto:</span>
                  <a v-bind:href="fileDownloadURL"
                    target="_blank">
                    Click para ver archivo adjunto
                  </a>
                </h6>
                <h6 class="mb-3">
                  <span class="d-block font-weight-bold">Comentarios:</span> {{pqr.comment}}
                </h6>
              </div>
            </div>
          </div>

          <div class="col-12 col-md-6 mb-5">
            <div class="card">
              <div class="card-header">
                <span class="font-weight-bold">Gestión administrativa</span>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-12 form-group">
                    <h5 class="font-weight-bold">
                      Tipo: <span class="badge badge-primary">{{pqr.type.toUpperCase()}}</span>
                    </h5>
                  </div>
                  <div class="col-12 form-group">
                    <label for="assignedTo">Funcionario asignado</label>
                    <select name="assignedTo"
                      id="assignedTo"
                      class="form-control"
                      v-model="$v.form.assignedTo.$model"
                      v-bind:disabled="isClosed">
                      <option value="" selected disabled>--- Seleccione una opción ---</option>
                      <option v-for="(official, index) in officials"
                        v-bind:key="index"
                        v-bind:value="official.value">
                        {{official.label}}
                      </option>
                    </select>
                    <template v-if="$v.form.assignedTo.$error">
                      <div class="invalid-feedback" v-if="!$v.form.assignedTo.required">Este campo es obligatorio</div>
                    </template>
                  </div>
                  <div class="col-12 form-group">
                    <label for="status">Estado</label>
                    <input type="text"
                      class="form-control"
                      value="CERRADO"
                      v-if="isClosed"
                      readonly>
                    <select name="status"
                      id="status"
                      class="form-control"
                      v-model="$v.form.status.$model"
                      v-bind:readonly="isClosed"
                      v-else>
                      <option value="" selected disabled>--- Seleccione una opción ---</option>
                      <option v-for="(status, index) in statuses"
                        v-bind:key="index"
                        v-bind:value="status">
                        {{status.toUpperCase()}}
                      </option>
                    </select>
                    <template v-if="$v.form.status.$error">
                      <div class="invalid-feedback" v-if="!$v.form.status.required">Este campo es obligatorio</div>
                    </template>
                  </div>

                  <div class="col-12 form-group">
                    <label for="notes">Observaciones</label>
                    <textarea name="notes"
                      id="notes"
                      cols="30"
                      rows="6"
                      class="form-control"
                      v-model="form.notes"
                      v-bind:readonly="isClosed">
                    </textarea>
                  </div>
  
                  <div class="col-12">
                    <hr>
                  </div>
                  
                  <div class="col-12 text-right"
                    v-if="!isClosed">
                    <button type="button"
                      class="btn btn-danger px-4 mr-2"
                      v-on:click="closePqr"
                      v-if="canClose">
                      Cerrar PQR
                    </button>
                    <input type="submit" value="Actualizar estado" class="btn btn-success px-4">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import { validationMixin, } from "vuelidate";
  import { required, } from "vuelidate/lib/validators";
  import { firestore, storage, } from '@/firebase';
  export default {
    mixins: [
      validationMixin,
    ],
    data() {
      return {
        form: {
          assignedTo: "",
          status: "",
          notes: ""
        },
        officials: [],
        statuses: [
          "pendiente",
          "en proceso",
        ],
        fileDownloadURL: null,
      };
    },
    computed: {
      pqrId() {
        return this.$route.params.id;
      },
      pqr() {
        return this.$store.state.editPqr;
      },
      isClosed() {
        return this.pqr.status == "cerrado";
      },
      hasFile() {
        return !!this.fileDownloadURL;
      },
      canClose() {
        return !this.isClosed && this.$store.state.editPqr.assignedTo;
      },
    },
    validations: {
      form: {
        assignedTo: { required, },
        status: { required, },
      }
    },
    methods: {
      async getOfficials() {
        const snapshot = await firestore.collection("users")
          .where("deleted", "==", false)
          .get();
        snapshot.forEach(doc => {
          this.officials.push({
            value: doc.id,
            label: `${doc.get("name")} ${doc.get("lastName")}`
          });
        });
      },
      async updatePqr() {
        this.$v.form.$touch();

        if (this.$v.form.$anyError)
          return;

        const updates = {...this.form};

        if (!this.$store.state.editPqr.assignedTo && this.form.assignedTo)
          updates.assignmentDate = new Date();

        if (!this.form.notes)
          updates.notes = "Sin observaciones.";

        try {
          await firestore.doc(`/pqrs/${this.pqrId}`).update(updates);
          setTimeout(() => this.$router.replace({ name: "Pqr", }), 500);
          this.$swal("Operación exitosa", "PQR actualizado con éxito", "success");
        } catch(e) {
          console.error(e);
          this.$swal("Error", e.toString(), "error");
        }
      },
      async closePqr() {
        try {
          await firestore.doc(`/pqrs/${this.pqrId}`).update({
            status: "cerrado",
            deadline: new Date(),
          });
          setTimeout(() => this.$router.replace({ name: "Pqr", }), 500);
          this.$swal("Operación exitosa", "PQR cerrado con éxito", "success");
        } catch(e) {
          console.error(e);
          this.$swal("Error", e.toString(), "error");
        }
      },
      async getFileDownloadURL() {
        try {
          const url = await storage.ref(`/pqrs/${this.pqrId}`).getDownloadURL();
          this.fileDownloadURL = url;
        } catch(e) {
          console.error();
        }
      },
    },
    created() {
      this.getFileDownloadURL();
      this.getOfficials();
      if (this.$store.state.editPqr) {
        const { assignedTo, status, notes, } = this.$store.state.editPqr;

        this.form = {
          ...this.form,
          assignedTo,
          status,
          notes,
        };
      }
      else
        this.$router.replace("/pqr");
    }
  };
</script>